import { render, staticRenderFns } from "./UserAgreement.vue?vue&type=template&id=d98dcee4&scoped=true"
import script from "./UserAgreement.vue?vue&type=script&lang=js"
export * from "./UserAgreement.vue?vue&type=script&lang=js"
import style0 from "./UserAgreement.vue?vue&type=style&index=0&id=d98dcee4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d98dcee4",
  null
  
)

export default component.exports